import styled, { css } from 'styled-components';

export const FileUploadWrapper = styled.div<{
  $inProgress: boolean;
}>`
  ${({ theme, $inProgress }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
    padding: ${theme.spacing(3)};
    border: 1px solid
      ${$inProgress ? theme.palette.error.main : theme.palette.neutral[60]};
    border-radius: ${theme.borderRadius.lg};
  `}
`;

export const FileUploadTitleWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `}
`;

export const FileUploadDescriptionContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.5)};
  `}
`;

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
    margin-top: ${theme.spacing(2)};
  `}
`;

export const VerticalDivider = styled.div`
  ${({ theme }) => css`
    width: 1px;
    align-self: stretch;
    background-color: ${theme.palette.neutral[60]};
  `}
`;
